import React from "react";
import { Route } from "react-router-dom";
import { LazyLoadRoutes } from "routes/lazyLoadRoutes";
import {
  GJS_THANKYOU_BUILDER_ROUTE_IDS,
  GJS_THANKYOU_BUILDER_ROUTE_KEYS,
} from "./ThankYouBuilder.constants";

const GJSThankYouBuilder = React.lazy(() =>
  import("../GJSThankYouBuilder").then((m) => ({
    default: m.GJSThankYouBuilder,
  }))
);

export const GJS_THANKYOU_BUILDER_CUSTOM_ROUTES = [
  <Route
    exact
    key={GJS_THANKYOU_BUILDER_ROUTE_IDS[GJS_THANKYOU_BUILDER_ROUTE_KEYS.update]}
    path={
      GJS_THANKYOU_BUILDER_ROUTE_IDS[GJS_THANKYOU_BUILDER_ROUTE_KEYS.update]
    }
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={GJSThankYouBuilder} />
    )}
    noLayout
  />,
];
